// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestGetBody = {
  poolId: string;
  contestId: string;
};

export type typeContestGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    contestId: string;
    name: string;
    seasonId: string;
    status:
      "upcoming" | "active" | "pendingOutcome" | "confirmed" | "cancelled";
    currentRoundId?: string | null;
    anchorTimeZone: string;
    configRevision: number;
    config: {
      startDate: string;
      endDate: string;
      roundGrouping: "day" | "week";
      weekStartDay?: number | null;
      roundLockTiming: "firstGame" | "lastGame";
      pickBasis: "moneyline" | "spread";
      spreadTiming?: "lockedEarly" | "live" | null;
      advanceCriterion: "winAll" | "winHalfOrMore";
      livesAllowed: number;
      requiredPicksPerRound: number;
      maxEntriesPerMember: number;
      teamReuseAllowed: boolean;
      teamReuseLockoutDays?: number | null;
      teamReuseMaxCount?: number | null;
      revivesAllowed: "unlimited" | "limited";
      revivesAllowedCount?: number | null;
      postponementPolicy: "makeUpNextRound" | "countAsLoss";
      tiePolicy: "tieIsWin" | "tieIsLoss";
      tiebreaker: "splitMedal" | "noWinner" | "commissionerPick";
      winPoints: number;
      lossPoints: number;
      skipsAllowed: boolean;
      skipsMaxPerContest?: number | null;
      endDateMode: "date" | "tbd";
    };
  };
};

export type typeContestGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    contestId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "contestId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestGetBody);
  }

  return async function postContestGet(
    payload: typeContestGetBody,
  ): Promise<typeContestGetOutput200 | typeContestGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestGet" failed before calling the network. #aa1af14d7161`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#aa1af14d7161" },
        },
        data: null,
      } as typeContestGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/get`,
      httpMethod: "POST",
      options,
    })) as typeContestGetOutput200 | typeContestGetOutput400;
  };
}
